import React from 'react';
import classNames from 'classnames';

import * as constants from 'eventbrite_design_system/globalHeader/constants';

import Icon from 'eventbrite_design_system/icon/Icon';

const GlobalHeaderLogo = ({ info }) => {
    const {
        url,
        iconType = constants.DEFAULT_LOGO_TYPE,
        iconColor = constants.DEFAULT_LOGO_COLOR,
        iconTitle = constants.DEFAULT_LOGO_TITLE,
        iconWidth = constants.DEFAULT_LOGO_SIZE.width,
        iconHeight = constants.DEFAULT_LOGO_SIZE.height,
        backgroundColor,
        shouldUseSpecialWidth,
        ...linkProps
    } = info;
    const className = classNames('consumer-header__logo-link', {
        [`eds-bg-color--${backgroundColor}`]: backgroundColor,
        'consumer-header--logo-special-width': !!shouldUseSpecialWidth,
    });

    return (
        <a
            href={url}
            className={className}
            data-spec="consumer-header-logo-link"
            {...linkProps}
        >
            <Icon
                type={iconType}
                color={iconColor}
                title={iconTitle}
                isBlockLevel={true}
                height={iconHeight}
                width={iconWidth}
                data-spec="consumer-header-logo"
            />
        </a>
    );
};

export default GlobalHeaderLogo;
